/* EF shelf viewer, perspective orbit rebuild 2026-09-05. Pinned Three r128.
 * Exterior shape only: stainless for the outdoor palette, black for other models.
 * Native controls own all commerce state.
 * Sections: UI / geometry / camera / dimensions / input / lifecycle.
 * Frames run only during interaction, transitions or a requested redraw.
 * No remote texture, price calculation or duplicate size input.
 */
(function () {
  'use strict';
  var T = window.THREE, mount = document.getElementById('efmShelf3D');
  if (!mount || !T || mount.hasAttribute('data-efm-3d-ready')) return;
  // EF_OUTDOOR_STAINLESS_3D_20260917: the existing palette is product-scoped.
  // This previews the stainless body, not the selected Endura coating.
  var stainless = !!(window.__EFM_CONFIG && window.__EFM_CONFIG.palette === 'endura');
  var renderer;
  try { renderer = new T.WebGLRenderer({ alpha: true, antialias: true }); }
  catch (_) { return; }
  var cleanups = [];
  function listen(target, name, fn, options) {
    target.addEventListener(name, fn, options);
    cleanups.push(function () { target.removeEventListener(name, fn, options); });
  }

  // UI: the canvas owns touch rotation; the surrounding panel remains scrollable.
  function element(tag, cls, text) {
    var el = document.createElement(tag); el.className = cls;
    if (text) el.textContent = text; return el;
  }
  var panel = mount.parentNode;
  var stage = element('div', 'efm-viewer-stage');
  var canvas = renderer.domElement;
  canvas.tabIndex = 0; canvas.setAttribute('role', 'img');
  canvas.style.touchAction = 'none';
  canvas.setAttribute('aria-keyshortcuts', 'ArrowLeft ArrowRight ArrowUp ArrowDown Home');
  stage.appendChild(canvas); mount.appendChild(stage);
  var controls = element('div', 'efm-viewer-controls');
  controls.setAttribute('role', 'group'); controls.setAttribute('aria-label', 'Shelf preview views');
  var buttons = {};
  [['3d', '3D'], ['front', 'Front'], ['side', 'Side'], ['reset', 'Reset']].forEach(function (item) {
    var btn = element('button', 'efm-viewer-button', item[1]); btn.type = 'button';
    btn.setAttribute('data-efm-view', item[0]);
    if (item[0] === 'reset') { btn.setAttribute('aria-label', 'Reset view'); btn.title = 'Reset view'; }
    if (item[0] !== 'reset') btn.setAttribute('aria-pressed', item[0] === '3d' ? 'true' : 'false');
    listen(btn, 'click', function () { setView(item[0]); });
    controls.appendChild(btn); buttons[item[0]] = btn;
  });
  mount.appendChild(controls);
  var readout = element('p', 'efm-viewer-dimensions'); readout.setAttribute('data-efm-3d-dimensions', '');
  readout.setAttribute('role', 'status'); readout.setAttribute('aria-live', 'polite'); mount.appendChild(readout);
  var note = element('p', 'efm-viewer-note'); note.setAttribute('data-efm-3d-note', ''); mount.appendChild(note);
  var oldCaption = document.getElementById('efmShelf3DCap');
  var scene = new T.Scene();
  var camera = new T.PerspectiveCamera(32, 2, 0.05, 80);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, stainless ? 2 : 1.75));
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = stainless ? T.PCFSoftShadowMap : T.PCFShadowMap;
  renderer.outputEncoding = T.sRGBEncoding;
  renderer.physicallyCorrectLights = true;
  renderer.toneMapping = T.ACESFilmicToneMapping; renderer.toneMappingExposure = 1;
  scene.add(new T.HemisphereLight(0xffffff, 0x72706c, 0.55));
  [[-2.5, 4, 4, 22], [5, 1, 5, 10], [0, 5, -3, 14]].forEach(function (p) {
    var light = new T.PointLight(0xffffff, p[3], 0, 2); light.position.set(p[0], p[1], p[2]); scene.add(light);
  });
  var keyLight = new T.DirectionalLight(0xffffff, 1.5);
  keyLight.position.set(-3, 5, 4); keyLight.castShadow = true;
  keyLight.shadow.mapSize.set(stainless ? 1024 : 512, stainless ? 1024 : 512);
  keyLight.shadow.camera.left = keyLight.shadow.camera.bottom = -4;
  keyLight.shadow.camera.right = keyLight.shadow.camera.top = 4;
  keyLight.shadow.camera.near = 0.5; keyLight.shadow.camera.far = 16;
  keyLight.shadow.bias = -0.0004; keyLight.shadow.normalBias = 0.02;
  keyLight.shadow.radius = 5; scene.add(keyLight);
  // Procedural studio softboxes give the black steel soft reflections, without
  // downloading a finish image or turning the preview into a second color picker.
  var environmentTarget;
  try {
    var studio = new T.Scene(); studio.background = new T.Color(stainless ? 0x24282c : 0x777777);
    var panels = [];
    // Broad reflection cards and a narrow rim give metal a readable rolled edge.
    var softboxes = stainless
      ? [[-4, 4, 6, 7, 5], [0, 6, -1, 12, 4], [5, 0, 3, 2, 7], [-5, 0, -2, 1, 5]]
      : [[-5, 4, 6, 5, 8], [1, 6, 0, 10, 5], [5, 1, 5, 3, 6]];
    softboxes.forEach(function (p) {
      var panelLight = new T.Mesh(new T.PlaneGeometry(p[3], p[4]), new T.MeshBasicMaterial({ color: new T.Color(1.2, 1.2, 1.2), side: T.DoubleSide }));
      panelLight.position.set(p[0], p[1], p[2]); panelLight.lookAt(0, 0, 0); studio.add(panelLight); panels.push(panelLight);
    });
    var pmrem = new T.PMREMGenerator(renderer); environmentTarget = pmrem.fromScene(studio, 0.06);
    scene.environment = environmentTarget.texture; pmrem.dispose();
    panels.forEach(function (p) { p.geometry.dispose(); p.material.dispose(); });
  } catch (_) { /* Direct studio lights remain available on a limited GPU. */ }
  // Restrained powder-coat microtexture; monochrome and generated once. Its
  // roughness variation breaks uniform computer-flat faces without a finish map.
  var grain = new Uint8Array(128 * 128 * 4), seed = 719;
  for (var i = 0; i < grain.length; i += 4) {
    seed = (seed * 1664525 + 1013904223) >>> 0;
    var shade = 170 + (seed >>> 27);
    grain[i] = grain[i + 1] = grain[i + 2] = shade; grain[i + 3] = 255;
  }
  var grainTexture = new T.DataTexture(grain, 128, 128, T.RGBAFormat);
  grainTexture.wrapS = grainTexture.wrapT = T.RepeatWrapping;
  grainTexture.magFilter = T.LinearFilter; grainTexture.minFilter = T.LinearMipmapLinearFilter;
  grainTexture.generateMipmaps = true; grainTexture.needsUpdate = true;
  var material = new T.MeshStandardMaterial({ roughness: 0.56, metalness: 0.3, envMapIntensity: 0.7,
    roughnessMap: grainTexture, bumpMap: grainTexture, bumpScale: 0.0003 });
  material.color.set('#202122').convertSRGBToLinear();
  var brushedTexture;
  if (stainless) {
    // Fine horizontal brushing, generated once. Correlated strokes avoid the
    // glitter/noise of powder coat. World-space UVs keep grain scale consistent.
    var brushedWidth = 512, brushedHeight = 256;
    var brushed = new Uint8Array(brushedWidth * brushedHeight * 4), brushedSeed = 9371;
    for (var by = 0; by < brushedHeight; by++) {
      brushedSeed = (brushedSeed * 1664525 + 1013904223) >>> 0;
      var rowShade = 184 + (brushedSeed >>> 28), stroke = 0;
      for (var bx = 0; bx < brushedWidth; bx++) {
        brushedSeed = (brushedSeed * 1664525 + 1013904223) >>> 0;
        stroke = stroke * 0.93 + ((brushedSeed >>> 28) - 7.5) * 0.07;
        var bi = (by * brushedWidth + bx) * 4, value = Math.round(rowShade + stroke);
        brushed[bi] = brushed[bi + 1] = brushed[bi + 2] = value; brushed[bi + 3] = 255;
      }
    }
    brushedTexture = new T.DataTexture(brushed, brushedWidth, brushedHeight, T.RGBAFormat);
    brushedTexture.wrapS = brushedTexture.wrapT = T.RepeatWrapping;
    brushedTexture.magFilter = T.LinearFilter; brushedTexture.minFilter = T.LinearMipmapLinearFilter;
    brushedTexture.anisotropy = Math.min(8, renderer.capabilities.getMaxAnisotropy());
    brushedTexture.generateMipmaps = true; brushedTexture.needsUpdate = true;
    material.color.set('#e0e3e5').convertSRGBToLinear();
    material.map = brushedTexture; material.metalness = 0.96; material.roughness = 0.38; material.envMapIntensity = 1.05;
    material.roughnessMap = brushedTexture; material.bumpMap = brushedTexture; material.bumpScale = 0.00012;
  }

  // Plain rectangular exterior from the product reference. The tiny edge radius
  // catches light without inventing a decorative bevel, band or mounting detail.
  function shellGeometry(w, h, d, radius) {
    var half = [w / 2, h / 2, d / 2], positions = [], normals = [], uvs = [], indices = [];
    var faces = [[0, 1, 2, 1], [0, 2, 1, -1], [1, 2, 0, 1], [1, 0, 2, -1], [2, 0, 1, 1], [2, 1, 0, -1]];
    faces.forEach(function (f) {
      var axis = f[0], u = f[1], v = f[2], sign = f[3], start = positions.length / 3;
      function edgeSamples(extent) {
        return [-extent, -extent + radius / 3, -extent + 2 * radius / 3, -extent + radius,
          extent - radius, extent - 2 * radius / 3, extent - radius / 3, extent];
      }
      var us = edgeSamples(half[u]), vs = edgeSamples(half[v]), stride = us.length;
      vs.forEach(function (vy) { us.forEach(function (ux) {
        var p = [0, 0, 0]; p[axis] = sign * half[axis]; p[u] = ux; p[v] = vy;
        var inner = p.map(function (value, i) { return Math.max(-half[i] + radius, Math.min(half[i] - radius, value)); });
        var normal = new T.Vector3(p[0] - inner[0], p[1] - inner[1], p[2] - inner[2]).normalize();
        positions.push(inner[0] + normal.x * radius, inner[1] + normal.y * radius, inner[2] + normal.z * radius);
        normals.push(normal.x, normal.y, normal.z);
        // Brush along shelf length on the front/top; along depth on end caps.
        if (stainless) uvs.push((axis === 0 ? p[2] : p[0]) * 0.7, (axis === 1 ? p[2] : p[1]) * 0.8);
        else uvs.push(ux * 4, vy * 4);
      }); });
      for (var y = 0; y < vs.length - 1; y++) for (var x = 0; x < us.length - 1; x++) {
        var a = start + y * stride + x, b = a + 1, c = a + stride, e = c + 1;
        indices.push(a, b, e, a, e, c);
      }
    });
    var geometry = new T.BufferGeometry();
    geometry.setAttribute('position', new T.Float32BufferAttribute(positions, 3));
    geometry.setAttribute('normal', new T.Float32BufferAttribute(normals, 3)); geometry.setIndex(indices);
    geometry.setAttribute('uv', new T.Float32BufferAttribute(uvs, 2));
    geometry.computeBoundingBox(); geometry.computeBoundingSphere(); return geometry;
  }
  var shelf = new T.Mesh(new T.BufferGeometry(), material); shelf.name = 'efm-shelf-exterior'; scene.add(shelf);
  // A real light-generated shadow under the object, not a sheared wall decal.
  shelf.castShadow = true;
  var shadowMaterial = new T.ShadowMaterial({ opacity: 0.15, transparent: true, depthWrite: false });
  var shadow = new T.Mesh(new T.PlaneGeometry(18, 18), shadowMaterial);
  shadow.rotation.x = -Math.PI / 2; shadow.receiveShadow = true;
  shadow.name = 'efm-shelf-contact-shadow'; scene.add(shadow);
  var dimensions = [48, 5, 8], world = [4, 5 / 12, 8 / 12];
  var hero = { yaw: -0.55, pitch: 0.37 };
  var yaw = hero.yaw, pitch = hero.pitch, distance = 8, orbitDistance = 8;
  var view = '3d', aspect = 2, motion = null, sizeMotion = null;
  var velocity = { yaw: 0, pitch: 0 }, lastTime = 0;
  var stopped = false, frameId = 0, shown = false, inView = true;
  var observer, intersection, removalObserver, pendingPointer = null;
  var media = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduced = !!(media && media.matches);
  function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }
  function ease(t) { return t * t * (3 - 2 * t); }
  function nearestAngle(target, from) { return from + Math.atan2(Math.sin(target - from), Math.cos(target - from)); }

  // Fit the actual bounding corners through a standard perspective lens.
  // No custom projection matrix or geometry shear is used in any view.
  function fitDistance(y, p) {
    var sy = Math.sin(y), cy = Math.cos(y), sp = Math.sin(p), cp = Math.cos(p);
    var tanV = Math.tan(camera.fov * Math.PI / 360), tanH = tanV * aspect;
    var result = 0.4;
    for (var ix of [-1, 1]) for (var iy of [-1, 1]) for (var iz of [-1, 1]) {
      var x = ix * world[0] * shelf.scale.x / 2;
      var yy = iy * world[1] * shelf.scale.y / 2;
      var z = iz * world[2] * shelf.scale.z / 2;
      var horizontal = cy * x - sy * z;
      var vertical = -sy * sp * x + cp * yy - cy * sp * z;
      var near = sy * cp * x + sp * yy + cy * cp * z;
      result = Math.max(result, near + Math.abs(horizontal) / (tanH * 0.92), near + Math.abs(vertical) / (tanV * 0.92));
    }
    return result + 0.08;
  }
  function positionCamera() {
    // During a flight, protect corners along the path as well as at its ends.
    var safe = Math.max(distance, fitDistance(yaw, pitch));
    camera.position.set(safe * Math.sin(yaw) * Math.cos(pitch), safe * Math.sin(pitch), safe * Math.cos(yaw) * Math.cos(pitch));
    camera.lookAt(0, 0, 0); camera.updateMatrixWorld(true);
  }
  function pressed() {
    Object.keys(buttons).forEach(function (key) {
      if (key !== 'reset') buttons[key].setAttribute('aria-pressed', key === view ? 'true' : 'false');
    });
  }
  function fly(nextYaw, nextPitch, duration) {
    velocity.yaw = velocity.pitch = 0;
    var target = { yaw: nearestAngle(nextYaw, yaw), pitch: nextPitch, distance: fitDistance(nextYaw, nextPitch) };
    if (reduced || !shown) {
      yaw = target.yaw; pitch = target.pitch; distance = target.distance; motion = null;
    } else {
      motion = { from: { yaw: yaw, pitch: pitch, distance: distance }, to: target, elapsed: 0, duration: duration || 650 };
    }
    orbitDistance = target.distance; requestRender();
  }
  function setView(next) {
    if (stopped) return;
    pointerEnd(); view = next === 'reset' ? '3d' : next; pressed();
    fly(view === 'side' ? Math.PI / 2 : view === 'front' ? 0 : hero.yaw, view === '3d' ? hero.pitch : 0);
  }
  function render(now) {
    frameId = 0;
    if (stopped || document.hidden || shown && (!inView || !stage.clientWidth)) { lastTime = 0; return; }
    var dt = lastTime ? Math.min(32, Math.max(0, now - lastTime)) : 16;
    lastTime = now; var active = false;
    if (sizeMotion) {
      sizeMotion.elapsed += dt;
      var sk = Math.min(1, sizeMotion.elapsed / 360), se = ease(sk);
      shelf.scale.set(sizeMotion.from[0] + (1 - sizeMotion.from[0]) * se, sizeMotion.from[1] + (1 - sizeMotion.from[1]) * se, sizeMotion.from[2] + (1 - sizeMotion.from[2]) * se);
      if (sk >= 1) sizeMotion = null; else active = true;
    }
    if (motion) {
      motion.elapsed += dt;
      var k = Math.min(1, motion.elapsed / motion.duration), e = ease(k);
      yaw = motion.from.yaw + (motion.to.yaw - motion.from.yaw) * e;
      pitch = motion.from.pitch + (motion.to.pitch - motion.from.pitch) * e;
      distance = motion.from.distance + (motion.to.distance - motion.from.distance) * e;
      if (k >= 1) motion = null; else active = true;
    } else if (!pendingPointer && !reduced && (Math.abs(velocity.yaw) > 0.008 || Math.abs(velocity.pitch) > 0.008)) {
      yaw += velocity.yaw * dt / 1000;
      pitch = clamp(pitch + velocity.pitch * dt / 1000, -0.2, 1.05);
      var decay = Math.exp(-6 * dt / 1000); velocity.yaw *= decay; velocity.pitch *= decay;
      distance = Math.max(orbitDistance, fitDistance(yaw, pitch)); active = true;
    } else if (!pendingPointer) { velocity.yaw = velocity.pitch = 0; }
    shadow.position.y = -world[1] * shelf.scale.y / 2 - 0.16;
    shadow.visible = view === '3d';
    positionCamera();
    try { renderer.render(scene, camera); } catch (_) { fallback(); return; }
    if (!shown) {
      shown = true; mount.classList.add('is-active'); panel.classList.add('efm-svg-hidden', 'efm-viewer-ready');
      if (oldCaption) oldCaption.hidden = true; resize();
    }
    if (active) requestRender(); else lastTime = 0;
  }
  function requestRender() {
    if (!stopped && !document.hidden && (!shown || inView) && !frameId) frameId = requestAnimationFrame(render);
  }
  function resize() {
    if (stopped) return;
    var w = stage.clientWidth || (!shown && panel.clientWidth);
    if (!w) return;
    var h = stage.clientHeight || parseFloat(getComputedStyle(stage).height) || 240;
    aspect = w / h; camera.aspect = aspect; camera.updateProjectionMatrix();
    renderer.setSize(w, h, false);
    distance = fitDistance(yaw, pitch); orbitDistance = distance;
    if (motion) { motion.from.distance = distance; motion.to.distance = fitDistance(motion.to.yaw, motion.to.pitch); }
    requestRender();
  }

  // Height/depth values are indexes; the displayed label carries the inches.
  var ids = ['efmLengthSelect', 'efmHeight', 'efmDepth'];
  function chosenInches(id) {
    var select = document.getElementById(id);
    if (!select || select.value === '' || !select.selectedOptions.length) return null;
    var match = select.selectedOptions[0].textContent.trim().match(/^(\d+(?:\.\d+)?)/);
    return match && Number(match[1]) > 0 ? Number(match[1]) : null;
  }
  function label() {
    var complete = ids.every(function (id) { return chosenInches(id) !== null; });
    var value = dimensions.map(function (n) { return Math.round(n * 100) / 100 + '″'; }).join(' × ');
    var text = (complete ? '' : 'Example: ') + value + ' · L × H × D';
    if (readout.textContent !== text) readout.textContent = text;
    note.textContent = stainless
      ? (complete ? 'Stainless steel shape preview. Drag to rotate; see finish photos for your selected color.' : 'Choose all three dimensions to preview your shelf. Stainless steel shown; see photos for finish colors.')
      : (complete ? 'Drag to rotate. Black shape preview; see photos for finish and mounting details.' : 'Choose all three dimensions to see your shelf. Drag to explore the black example.');
    canvas.setAttribute('aria-label', (complete ? 'Your shelf' : 'Example shelf') + (stainless ? ', stainless steel preview: ' : ', shown in black: ') + dimensions[0] + ' inches long, ' + dimensions[1] + ' inches high, ' + dimensions[2] + ' inches deep. Drag in any direction or use arrow keys to rotate. Home resets the view.');
  }
  function setDimensions(L, H, D) {
    var next = [Number(L), Number(H), Number(D)];
    if (stopped || !next.every(function (n) { return isFinite(n) && n > 0; })) return;
    if (next.every(function (n, i) { return n === dimensions[i]; }) && shelf.geometry.attributes.position) { label(); return; }
    var targetYaw = motion ? motion.to.yaw : yaw;
    var targetPitch = motion ? motion.to.pitch : pitch;
    var previous = world.map(function (n, i) { return n * shelf.scale.getComponent(i); });
    dimensions = next; var unit = 4 / next[0]; world = next.map(function (n) { return n * unit; });
    var old = shelf.geometry;
    shelf.geometry = shellGeometry(world[0], world[1], world[2], Math.min(0.12 * unit, world[1] / 18, world[2] / 18));
    var start = previous.map(function (n, i) { return n / world[i]; });
    sizeMotion = shown && !reduced ? { from: start, elapsed: 0 } : null;
    if (sizeMotion) shelf.scale.fromArray(start); else shelf.scale.set(1, 1, 1);
    old.dispose(); label();
    // Preserve the chosen preset during a dimension change mid-flight.
    // Rebase from the current pose so the new proportions never cause a jump.
    velocity.yaw = velocity.pitch = 0;
    var currentScale = shelf.scale.clone(); shelf.scale.set(1, 1, 1);
    var targetDistance = fitDistance(targetYaw, targetPitch); shelf.scale.copy(currentScale);
    if (shown && !reduced) motion = { from: { yaw: yaw, pitch: pitch, distance: distance }, to: { yaw: targetYaw, pitch: targetPitch, distance: targetDistance }, elapsed: 0, duration: 420 };
    else { motion = null; yaw = targetYaw; pitch = targetPitch; distance = targetDistance; }
    orbitDistance = targetDistance; requestRender();
  }
  function syncNative() { setDimensions.apply(null, ids.map(function (id, i) { return chosenInches(id) || [48, 5, 8][i]; })); }

  // Capture one pointer immediately so touch drags rotate on both axes.
  // Only the canvas consumes gestures; page scrolling works outside the canvas.
  function pointerDown(e) {
    if (stopped || e.isPrimary === false || e.button !== 0 || pendingPointer) return;
    velocity.yaw = velocity.pitch = 0;
    pendingPointer = { id: e.pointerId, x: e.clientX, y: e.clientY, startX: e.clientX, startY: e.clientY, last: e.timeStamp, accepted: true, moved: false };
    if (pendingPointer.accepted && canvas.setPointerCapture) canvas.setPointerCapture(e.pointerId);
  }
  function pointerEnd(e) {
    var state = pendingPointer;
    if (e && state && e.pointerId != null && e.pointerId !== state.id) return;
    pendingPointer = null; canvas.classList.remove('is-dragging');
    if (!state || !state.accepted || !e || e.type !== 'pointerup' || reduced || e.timeStamp - state.last > 100) velocity.yaw = velocity.pitch = 0;
    if (state && canvas.hasPointerCapture && canvas.hasPointerCapture(state.id)) canvas.releasePointerCapture(state.id);
    requestRender();
  }
  function pointerMove(e) {
    var state = pendingPointer; if (!state || e.pointerId !== state.id) return;
    var horizontal = e.clientX - state.startX, vertical = e.clientY - state.startY;
    if (e.cancelable) e.preventDefault();
    if (!state.moved) {
      if (Math.abs(horizontal) < 2 && Math.abs(vertical) < 2) return;
      motion = null; orbitDistance = Math.max(distance, fitDistance(yaw, pitch)); state.moved = true;
    }
    view = '3d'; pressed(); canvas.classList.add('is-dragging');
    var dy = -(e.clientX - state.x) * 0.007;
    var dp = (e.clientY - state.y) * 0.005;
    var seconds = clamp((e.timeStamp - state.last) / 1000, 0.008, 0.06);
    yaw += dy; pitch = clamp(pitch + dp, -0.2, 1.05);
    velocity.yaw = clamp(0.4 * velocity.yaw + 0.6 * dy / seconds, -3.5, 3.5);
    velocity.pitch = clamp(0.4 * velocity.pitch + 0.6 * dp / seconds, -1.5, 1.5);
    distance = Math.max(orbitDistance, fitDistance(yaw, pitch));
    state.x = e.clientX; state.y = e.clientY; state.last = e.timeStamp; requestRender();
  }
  listen(canvas, 'pointerdown', pointerDown); listen(canvas, 'pointermove', pointerMove);
  listen(canvas, 'pointerup', pointerEnd); listen(canvas, 'pointercancel', pointerEnd);
  listen(canvas, 'lostpointercapture', function () { if (pendingPointer) pointerEnd(); });
  listen(canvas, 'keydown', function (e) {
    if (e.key === 'Home') setView('reset');
    else {
      var ty = motion ? motion.to.yaw : yaw, tp = motion ? motion.to.pitch : pitch;
      if (e.key === 'ArrowLeft') ty += 0.16;
      else if (e.key === 'ArrowRight') ty -= 0.16;
      else if (e.key === 'ArrowUp') tp += 0.1;
      else if (e.key === 'ArrowDown') tp -= 0.1;
      else return;
      pointerEnd(); view = '3d'; pressed(); fly(ty, clamp(tp, -0.2, 1.05), 220);
    }
    e.preventDefault(); e.stopPropagation();
  });
  function fallback() {
    if (stopped) return;
    stopped = true; pointerEnd(); if (frameId) cancelAnimationFrame(frameId); frameId = 0;
    if (observer) observer.disconnect(); if (intersection) intersection.disconnect(); if (removalObserver) removalObserver.disconnect();
    cleanups.forEach(function (fn) { fn(); }); cleanups = [];
    mount.classList.remove('is-active'); panel.classList.remove('efm-svg-hidden', 'efm-viewer-ready');
    if (oldCaption) oldCaption.hidden = false;
    shelf.geometry.dispose(); material.dispose(); grainTexture.dispose(); shadow.geometry.dispose(); shadowMaterial.dispose();
    if (brushedTexture) brushedTexture.dispose();
    if (environmentTarget) environmentTarget.dispose();
    if (keyLight.shadow.map) keyLight.shadow.map.dispose(); renderer.dispose();
  }
  listen(canvas, 'webglcontextlost', function (e) { e.preventDefault(); fallback(); });
  listen(document, 'visibilitychange', function () {
    if (document.hidden) { pointerEnd(); if (frameId) cancelAnimationFrame(frameId); frameId = 0; lastTime = 0; }
    else requestRender();
  });
  listen(window, 'blur', function () { pointerEnd(); });
  listen(window, 'pagehide', function (e) { if (!e.persisted) fallback(); });
  ids.forEach(function (id) { var el = document.getElementById(id); if (el) listen(el, 'change', syncNative); });
  listen(window, 'load', syncNative, { once: true });
  if (media) {
    var changeMotion = function () {
      reduced = media.matches;
      if (reduced) {
        velocity.yaw = velocity.pitch = 0;
        if (motion) { yaw = motion.to.yaw; pitch = motion.to.pitch; distance = motion.to.distance; motion = null; }
        if (sizeMotion) { shelf.scale.set(1, 1, 1); sizeMotion = null; }
      }
      requestRender();
    };
    if (media.addEventListener) listen(media, 'change', changeMotion);
    else if (media.addListener) { media.addListener(changeMotion); cleanups.push(function () { media.removeListener(changeMotion); }); }
  }
  if (window.ResizeObserver) { observer = new ResizeObserver(resize); observer.observe(stage); }
  else listen(window, 'resize', resize);
  if (window.IntersectionObserver) {
    intersection = new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
      if (inView) requestRender();
      else if (shown) { pointerEnd(); if (frameId) cancelAnimationFrame(frameId); frameId = 0; lastTime = 0; }
    }); intersection.observe(panel);
  }
  if (window.MutationObserver) {
    removalObserver = new MutationObserver(function () { if (!mount.isConnected) fallback(); });
    removalObserver.observe(document.body, { childList: true, subtree: true });
  }
  mount.setAttribute('data-efm-3d-ready', 'orbit-v4-touch');
  window.EFMantel3D = { setDims: setDimensions, setFinish: function () { /* Neutral body preview; finish photos remain authoritative. */ } };
  syncNative(); resize();
})();
